const CART_STORAGE_KEY = 'pp_cart_v1';

function toSafePositiveInt(value, fallback = 1) {
  const parsed = Number.parseInt(String(value), 10);
  if (Number.isNaN(parsed) || parsed <= 0) {
    return fallback;
  }

  return Math.min(parsed, 50);
}

function normalizeCartItem(raw) {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const id = typeof raw.id === 'string' ? raw.id : '';
  const slug = typeof raw.slug === 'string' ? raw.slug : '';
  const name = typeof raw.name === 'string' ? raw.name : '';

  if (!id || !slug || !name) {
    return null;
  }

  return {
    id,
    slug,
    name,
    description: typeof raw.description === 'string' ? raw.description : '',
    image_url: typeof raw.image_url === 'string' ? raw.image_url : '',
    price_cents: Number(raw.price_cents) > 0 ? Number(raw.price_cents) : 0,
    weight_grams: Number(raw.weight_grams) > 0 ? Number(raw.weight_grams) : 0,
    qty: toSafePositiveInt(raw.qty)
  };
}

export function loadCart() {
  try {
    const raw = window.localStorage.getItem(CART_STORAGE_KEY);
    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.map(normalizeCartItem).filter(Boolean);
  } catch {
    return [];
  }
}

export function saveCart(items) {
  window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
}

export function upsertCartItem(items, product, qtyToAdd = 1) {
  const qty = toSafePositiveInt(qtyToAdd, 1);
  const existing = items.find((item) => item.id === product.id);

  if (existing) {
    return items.map((item) =>
      item.id === product.id
        ? {
            ...item,
            qty: Math.min(item.qty + qty, 50)
          }
        : item
    );
  }

  return [
    ...items,
    {
      id: product.id,
      slug: product.slug,
      name: product.name,
      description: product.description || '',
      image_url: product.image_url || '',
      price_cents: Number(product.price_cents) || 0,
      weight_grams: Number(product.weight_grams) || 0,
      qty
    }
  ];
}

export function setCartItemQty(items, productId, nextQty) {
  const qty = toSafePositiveInt(nextQty, 0);

  if (qty <= 0) {
    return items.filter((item) => item.id !== productId);
  }

  return items.map((item) =>
    item.id === productId
      ? {
          ...item,
          qty
        }
      : item
  );
}

export function removeCartItem(items, productId) {
  return items.filter((item) => item.id !== productId);
}

export function clearCart() {
  window.localStorage.removeItem(CART_STORAGE_KEY);
}

export function getCartCount(items) {
  return items.reduce((acc, item) => acc + item.qty, 0);
}

export function getCartTotals(items) {
  return items.reduce(
    (acc, item) => {
      acc.subtotalCents += item.price_cents * item.qty;
      acc.totalWeightGrams += item.weight_grams * item.qty;
      return acc;
    },
    { subtotalCents: 0, totalWeightGrams: 0 }
  );
}

export function toCheckoutItems(items) {
  return items.map((item) => ({
    productId: item.id,
    qty: item.qty
  }));
}
